/**
 * Блок с гарантией
 */
export const GUARANTEE_BREAKPOINT = {
    breakpoints: {
        320: {
            slidesPerView: 1.35,
            spaceBetween: 25,
        },
    },
};
